import React, { Component } from 'react';
import SuccessPopper from './../../assets/popper.jpg';
import './success-page-styles.scss';
import {
    Button, ButtonType
} from 'office-ui-fabric-react';
import { Link } from "react-router-dom";
import Config from './../../config/app-configuration';

export class SuccessPage extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        return (
            <div className="successPage">
                <div>
                    <p className="success-text">Congratulations!!</p>
                    <img className="success-image" src={SuccessPopper} alt="Success" />
                    <div className="success-actions">
                        <Link to="/deals" className="success-link">
                            <Button buttonType={ButtonType.primary}>View Deals</Button>
                        </Link>
                        <a className="success-link" style={{ marginTop: "10px" }} target="_blank" rel="noopener noreferrer" href={`${Config.dealflowAppUrl}deal/${this.props.dealid}?teamid=${this.props.teamid}`}>
                            <Button buttonType={ButtonType.primary}>Go to Fundwave</Button>
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default SuccessPage